import * as angular from 'angular';
import {ContractStatusController, ViewContractStatusController} from './contract-status-controllers';
import FeaturetypeModalController from './contract-status-modal-controllers';

export default angular.module('dataforvalter.contract-status', [
    'dataforvalter.security',
    'ui.bootstrap',
    'dataforvalter.contract-features-table-react'
])
    .controller('ContractStatusController', ContractStatusController)
    .controller('ViewContractStatusController', ViewContractStatusController)
    .controller('FeaturetypeModalController', FeaturetypeModalController)
.name;
